import { Topic } from "@shapeable/gesda-types";


export const editionFilter = (topics: Topic[]): Topic[] => {
  return topics.filter((topic) => topic.editions.some((edition) => (
    edition.numericValue === Number(process.env.CURRENT_EDITION)
  )));
}